<template>
  <div class="sc-row">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>




// WEBPACK FOOTER //
// BaseFormRow.vue?6c607a0b